'use client'

import React, { useEffect, useState } from 'react'
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export function Smoothup({ children, className, ...props }: { children: React.ReactNode; className?: string; delay?: number; [key: string]: unknown }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, margin: "-10%" });
  const [hasAnimated, setHasAnimated] = useState(false);

  // Reset animation state when component mounts (e.g., on navigation)
  useEffect(() => {
    const resetTimer = setTimeout(() => {
      setHasAnimated(false);
    }, 100);
    return () => clearTimeout(resetTimer);
  }, []);

  // Track if element should animate
  useEffect(() => {
    if (isInView && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [isInView, hasAnimated]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 40 }}
      animate={hasAnimated ? { y: 0, opacity: 1 } : { opacity: 0, y: 40 }}
      transition={{ duration: 0.3, ease: "easeInOut", type: 'spring', stiffness: 100, delay: props.delay || 0 }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
}